import HomePage from './pages/home.vue'
import DishPage from './pages/dish.vue'
import Calendar from './pages/calendar.vue'
import Setting from './pages/setting.vue'
import NotFoundPage from './pages/not-found.vue'


const routes = [
    {
        path: '/',
        //url: './pages/home.vue'
        component: HomePage
    },
    {
        path: '/task/:id/',
        component: DishPage
    },
    {
        path: '/calendar/',
        component: Calendar
    },
    {
        path: '/setting/',
        component: Setting
    },
    {
      path: '(.*)',
      url: './pages/not-found.vue'
    }
];


export default routes;


// WEBPACK FOOTER //
// ./src/routes.js